import { OverlayTrigger, Popover } from "react-bootstrap";

import { DateTime } from "luxon";

import {
  AppointmentStatusSlug,
  getAppointmentStatusValues,
} from "../../../_constants/appointment";
import { getDateFromIso } from "../../../_helpers/stringHelper";
import ColoredMarker from "../../../common/components/ColoredMarker";


interface OrderStatusesProps {
  statuses: any[];
}

const OrderStatuses = ({ statuses }: OrderStatusesProps) => {
  const getStatusFromSlug = (slug: string) => {
    return statuses.filter((entry) => entry?.status?.slug === slug)[0];
  };

  const getHintOrNotYet = (slug: string, hint: string, notYet: string) => {
    let hintText = notYet;
    const status = getStatusFromSlug(slug);
    if (status) {
      hintText =
        getDateFromIso(status?.createdAt, DateTime.DATETIME_SHORT) +
        " - " +
        hint;
    }
    return hintText;
  };

  return (
    <div className="d-flex justify-content-center align-items-center  flex-wrap">
      {Object.values(AppointmentStatusSlug).map((slug) => {
        const { color, hint, name, notYet } = getAppointmentStatusValues(slug);
        return (
          <div key={slug} className="mx-1 my-1">
            {hint !== undefined && (
              <OverlayTrigger
                trigger={["hover", "focus"]}
                placement={"bottom"}
                overlay={
                  <Popover id={`actionsComponentLink`}>
                    <Popover.Body className="p-0 m-2 popoverTextSecondary">
                      <strong>{getHintOrNotYet(slug, hint, notYet)}</strong>
                    </Popover.Body>
                  </Popover>
                }
              >
                <div className="mx-2" style={{ cursor: "pointer" }}>
                  <ColoredMarker
                    color={getStatusFromSlug(slug) ? color : "#444444"}
                  >
                    {name}
                  </ColoredMarker>
                </div>
              </OverlayTrigger>
            )}
            {hint === undefined && (
              <div className="mx-2" style={{ cursor: "pointer" }}>
                <ColoredMarker color={color}>{name || "Tous"}</ColoredMarker>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default OrderStatuses;
